module.exports = {
      id: "sponsored-usage",
      viewBox: "0 0 32 19.199",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#sponsored",
      toString: function () {
        return this.url;
      }
    }